import React from "react";
import { useTranslation } from "react-i18next";
import { IVideoStream } from "../../providers/videoStreams/videoStreams.interface";
import VideoStreamCard from "../VideoStreamCard";
import { ListContainer } from "./styles";

interface IProps {
  currentItems: IVideoStream[];
}

const VideoStreamList: React.FC<IProps> = ({ currentItems }) => {
  const { t } = useTranslation();

  return (
    <ListContainer>
      {currentItems.length > 0 ? (
        <div className="videoList">
          {currentItems.map((video: IVideoStream) => (
            <VideoStreamCard key={video.id} video={video} />
          ))}
        </div>
      ) : (
        <div className="emptyState">
          <p>{t("no_videos_found")}</p>
        </div>
      )}
    </ListContainer>
  );
};

export default VideoStreamList;
